
const ThankYouPage = () => (
<div className="p-8 text-center">
    <h2 className="text-3xl font-bold text-green-600">Teşekkürler!</h2>
    <p className="mt-4">Siparişiniz başarıyla oluşturuldu.</p>
</div>
);

export default ThankYouPage;
  